import PageFooter from '@/components/PageFooter'
import PageHeader from '@/components/PageHeader'
import StepTracker from '@/components/StepTracker'
import { ACCESS, KPI, NETWORK, ROUTES } from '@/constants'
import AddBilling from '@/pages/AddBilling'
import AddCard from '@/pages/AddCard'
import AddShipping from '@/pages/AddShipping'
import CardDetails from '@/pages/CardDetails'
import ComingSoon from '@/pages/ComingSoon'
import Cvc from '@/pages/Cvc'
import EmailConfirmation from '@/pages/EmailConfirmation'
import Entry from '@/pages/Entry'
import FrequentlyAskedQuestions from '@/pages/FAQ'
import ListCards from '@/pages/ListCards'
import ListCardsUnprovisioned from '@/pages/ListCardsUnprovisioned'
import ListShipping from '@/pages/ListShipping'
import Message from '@/pages/Message'
import ProfileCreation from '@/pages/ProfileCreation'
import ProfileHome from '@/pages/ProfileHome'
import Reacceptance from '@/pages/Reacceptance'
import RegisterBilling from '@/pages/RegisterBilling'
import RegisterTerms from '@/pages/RegisterTerms'
import ReviewProvision from '@/pages/ReviewProvision'
import Settings from '@/pages/Settings'
import Support from '@/pages/Support'
import MdesChallenge from '@/pages/authentication/MdesChallenge'
import MdesMethodSelect from '@/pages/authentication/MdesMethodSelect'
import ThreeDsChallenge from '@/pages/authentication/ThreeDsChallenge'
import Confirmation from '@/pages/settings/Confirmation'
import ConnectionSettings from '@/pages/settings/Connections'
import ContactInformationSettings from '@/pages/settings/ContactInformation.vue'
import ContactInformationSupport from '@/pages/settings/ContactInformationSupport.vue'
import Language from '@/pages/settings/Language'
import ProfileSettings from '@/pages/settings/Profile'
import ThemeSettings from '@/pages/settings/Theme'
import VerifyAccount from '@/pages/verify/Account'
import VerifyMobile from '@/pages/verify/Mobile'

const commonComponents = { PageHeader, PageFooter, StepTracker }

const routes = [
  {
    path: '/enroll',
    name: ROUTES.ENTRY,
    components: { default: Entry, ...commonComponents },
    meta: { access: ACCESS.LOBBY, title: 'pageTitles.default' }
  },
  {
    path: '/email-confirmation',
    name: ROUTES.EMAIL_CONFIRMATION,
    components: { default: EmailConfirmation, ...commonComponents },
    meta: { access: ACCESS.CLEARANCE, title: 'pageTitles.emailConfirmation' },
    props: {
      PageHeader: { hideMenu: true, hideLocaleButton: true }
    }
  },
  {
    path: '/profile-creation',
    name: ROUTES.PROFILE_CREATION,
    components: { default: ProfileCreation, ...commonComponents },
    meta: { access: ACCESS.CLEARANCE, title: 'pageTitles.profileCreation' },
    props: {
      PageHeader: { hideMenu: true }
    }
  },
  {
    path: '/home',
    name: ROUTES.PROFILE_HOME,
    components: { default: ProfileHome, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.profileHome' }
  },
  {
    path: '/card/list',
    name: ROUTES.LIST_CARDS,
    components: { default: ListCards, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.listCards' }
  },
  {
    path: '/card/details',
    name: ROUTES.CARD_DETAILS,
    components: { default: CardDetails, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.cardDetails' }
  },
  {
    path: '/card/add',
    name: ROUTES.ADD_CARD,
    components: { default: AddCard, ...commonComponents },
    meta: { access: ACCESS.CLEARANCE, title: 'pageTitles.addCard' }
  },
  {
    path: '/card/billing',
    name: ROUTES.ADD_BILLING,
    components: { default: AddBilling, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.billingAddress' }
  },
  {
    path: '/enroll/billing',
    name: ROUTES.REGISTER_BILLING,
    components: { default: RegisterBilling, ...commonComponents },
    meta: { access: ACCESS.LOBBY, title: 'pageTitles.billingAddress' }
  },
  {
    path: '/enroll/terms',
    name: ROUTES.REGISTER_TERMS,
    components: { default: RegisterTerms, ...commonComponents },
    meta: { access: ACCESS.LOBBY, title: 'pageTitles.termsAndConditions' }
  },
  {
    path: '/provision/list',
    name: ROUTES.LIST_CARDS_UNPROVISIONED,
    components: { default: ListCardsUnprovisioned, ...commonComponents },
    meta: {
      access: ACCESS.CLEARANCE,
      title: 'pageTitles.listCardsUnprovisioned'
    }
  },
  {
    path: '/provision/review',
    name: ROUTES.REVIEW_PROVISION,
    components: { default: ReviewProvision, ...commonComponents },
    meta: {
      access: ACCESS.CLEARANCE,
      title: 'pageTitles.reviewProvision'
    },
    props: {
      PageHeader: {
        backButtonRoute: { name: ROUTES.LIST_CARDS_UNPROVISIONED }
      }
    }
  },
  {
    path: '/shipping/list',
    name: ROUTES.LIST_SHIPPING,
    components: { default: ListShipping, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.listShipping' }
  },
  {
    path: '/shipping/add',
    name: ROUTES.ADD_SHIPPING,
    components: { default: AddShipping, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.addShipping' }
  },
  {
    path: '/error',
    name: ROUTES.ERROR,
    components: { default: Message, ...commonComponents },
    meta: { title: 'pageTitles.error' },
    props: {
      PageHeader: { hideLocaleButton: true }
    }
  },
  {
    path: '/coming-soon',
    name: ROUTES.COMING_SOON,
    components: { default: ComingSoon, ...commonComponents },
    meta: { title: 'pageTitles.comingSoon' },
    props: {
      PageHeader: { basic: true },
      PageFooter: { basic: true, hidePrivacy: false }
    }
  },
  {
    path: '/unavailable',
    name: ROUTES.UNAVAILABLE,
    components: { default: Message, ...commonComponents },
    meta: { title: 'pageTitles.unavailable' },
    props: {
      PageHeader: { basic: true, hideLocaleButton: true },
      PageFooter: { basic: true, hidePrivacy: true }
    }
  },
  {
    path: '/confirmation',
    name: ROUTES.CONFIRM,
    components: { default: Confirmation, ...commonComponents },
    meta: { title: 'pageTitles.confirm' }
  },
  {
    path: '/settings',
    name: ROUTES.SETTINGS,
    components: { default: Settings, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.settings' }
  },
  {
    path: '/settings/connections',
    name: ROUTES.CONNECTION_SETTINGS,
    components: { default: ConnectionSettings, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.connectionSettings' }
  },
  {
    path: '/settings/profile',
    name: ROUTES.PROFILE_SETTINGS,
    components: { default: ProfileSettings, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.profileSettings' }
  },
  {
    path: '/settings/mobile',
    name: ROUTES.CONTACT_INFORMATION_SETTINGS,
    components: { default: ContactInformationSettings, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.contactInformationSettings' }
  },
  {
    path: '/settings/mobile-support',
    name: ROUTES.CONTACT_INFORMATION_SUPPORT,
    components: { default: ContactInformationSupport, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.contactInformationSupport' }
  },
  {
    path: '/settings/language',
    name: ROUTES.LANGUAGE,
    components: { default: Language, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.language' }
  },
  {
    path: '/settings/theme',
    name: ROUTES.THEME_SETTINGS,
    components: { default: ThemeSettings, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.theme' }
  },
  {
    path: '/support',
    name: ROUTES.SUPPORT,
    components: { default: Support, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.support' }
  },
  {
    path: '/faq',
    name: ROUTES.FAQ,
    components: { default: FrequentlyAskedQuestions, ...commonComponents },
    meta: { title: 'pageTitles.FAQ' },
    props: {
      PageHeader: { sticky: true }
    }
  },
  {
    path: '/verify/account',
    name: ROUTES.VERIFY_ACCOUNT,
    components: { default: VerifyAccount, ...commonComponents },
    meta: {
      access: ACCESS.LOBBY,
      title: 'pageTitles.otp',
      analyticsPageLoad: (vm) => ({
        event: vm.$EVENTS.PAGE_LOAD,
        meta: {
          otpNetwork: NETWORK.MASTERCARD,
          otpChannel: vm.$store.state.identity.verificationChannelUsed.toLowerCase()
        }
      })
    },
    props: {
      PageHeader: { hideLocaleButton: true }
    }
  },
  {
    path: '/verify/mobile',
    name: ROUTES.VERIFY_MOBILE,
    components: { default: VerifyMobile, ...commonComponents },
    meta: { access: ACCESS.PROTECTED, title: 'pageTitles.otp' }
  },
  {
    path: '/verify/options',
    name: ROUTES.VERIFY_OPTIONS,
    components: { interrupt: MdesMethodSelect, ...commonComponents },
    meta: { title: 'pageTitles.issuerOptions' },
    props: {
      PageHeader: {
        hideLocaleButton: true,
        hideMenu: true,
        canCancelChallenge: true,
        showIssuer: true,
        showCloseButton: true
      }
    }
  },
  {
    path: '/verify/issuer',
    name: ROUTES.VERIFY_ISSUER,
    components: { interrupt: MdesChallenge, ...commonComponents },
    meta: {
      title: 'pageTitles.otp',
      kpiPageLoad: () => ({
        resource: KPI.RESOURCE.IDV_AUTHENTICATION_SCREEN,
        operation: KPI.OPERATION.PAGE_LOAD,
        state: KPI.STATE.COMPLETED
      })
    },
    props: {
      PageHeader: {
        hideLocaleButton: true,
        hideMenu: true,
        canCancelChallenge: true,
        showIssuer: true,
        showCloseButton: true
      }
    }
  },
  {
    // 'verify' is an inappropriate path name; this is cardholder auth, not profile verification
    // TODO: follow up with product on appropriate URL
    path: '/verify/issuer-challenge',
    name: ROUTES.VERIFY_ISSUER_CHALLENGE,
    components: { interrupt: ThreeDsChallenge, ...commonComponents },
    meta: {
      title: 'pageTitles.issuerChallenge',
      kpiPageLoad: () => ({
        resource: KPI.RESOURCE.IDV_AUTHENTICATION_SCREEN,
        operation: KPI.OPERATION.PAGE_LOAD,
        state: KPI.STATE.COMPLETED
      })
    },
    props: {
      PageHeader: {
        hideLocaleButton: true,
        hideMenu: true,
        idCheck: true,
        canCancelChallenge: true,
        showCloseButton: true
      }
    }
  },
  {
    path: '/cvc',
    name: ROUTES.CVC,
    components: { interrupt: Cvc, ...commonComponents },
    meta: { title: 'pageTitles.cvc' }
  },
  {
    path: '/reacceptance',
    name: ROUTES.REACCEPTANCE,
    components: { default: Reacceptance, ...commonComponents },
    meta: { access: ACCESS.CLEARANCE, title: 'pageTitles.reacceptance' }
  }
]

export default routes
